import * as React from 'react';
import { isEmpty } from 'lodash';
import { ImageTransformationTemplateEntity } from '../types';
import computeSrcset from '../helpers/responsiveImages';

interface ImageProps {
  src: string;
  alt?: string;
  className?: string;
  style?: React.CSSProperties;
  transformationTemplates?: ImageTransformationTemplateEntity;
  onLoad?: (e: React.SyntheticEvent<HTMLImageElement, Event>) => void;
}

function Image({
  src,
  alt = '',
  className,
  style,
  transformationTemplates = { 1: '' },
  onLoad = (): void => {}
}: ImageProps): React.ReactElement {
  const [mainImage, ...retinaImages]: string[] = computeSrcset(src, transformationTemplates);

  return isEmpty(src) ? (
    <img alt="coming soon" src={`${window.bbGlobal.staticHost}/static/images/misc/pdp/loupe_image_coming_soon.jpg`} />
  ) : (
    <img
      alt={alt}
      src={mainImage}
      className={className}
      style={style}
      srcSet={retinaImages.join(', ')}
      onLoad={onLoad}
    />
  );
}

export default Image;
